import Modal from './components/Modal.svelte';
  
const modal = new Modal({
  target: document.body,
  props: {
    session: null,
    video: null,
    download: {
      formId: null,
      title: null
    }
  },
});

window.onload = () => {
  if (window.wordpress_object.is_download) {
    initSession();

    setInterval(function () {
      if (document.querySelectorAll('.toggle-modal').length > 1) {
        initSession();
      }
    }, 1000);
  }

}


function initSession() {
  const buttons = document.querySelectorAll('.toggle-modal');

  for (const button of buttons) {
    if (!button.onclick) {
      button.onclick = (e) => {
        e.preventDefault();

        const session = e.target.getAttribute('data-session');
        modal.session = session;
      };
    }
  }
}
